(function () {
  'use strict';
  angular.module('obex').
    factory('toastFactory', ['toastr',
      (toastr) => {
        return {

            toast_error(errMsg) {
                toastr.error(errMsg, 'Error', {
                closeButton: true,
                timeOut: 3500,
                });
            },

            toast_warn(warnMsg) {
                toastr.warning(warnMsg, 'Alert', {
                closeButton: true,
                timeOut: 3500,
                });
            },

            toast_info(infoMsg) {
                toastr.info(infoMsg, 'Info', {
                closeButton: true,
                timeOut: 3500,
                });
            },

        };
      },
    ]);
})();



// WEBPACK FOOTER //
// ./client/js/services/toast.factory.js